/**
 * ProductModalController
 * `.product-trigger[data-target]` クリックで `.product-modal` に is-active を付与し、
 * `[data-content="<target>"]` パネルだけ表示する。閉じるボタンで解除。
 *
 * HTML構造:
 * <a class="product-trigger" data-target="orsay">...</a>
 * <div class="product-modal">
 *   <button class="product-modal__close">×</button>
 *   <div class="product-modal__inner">
 *     <div class="product-modal__content" data-content="orsay">...</div>
 *     <div class="product-modal__content" data-content="traviata">...</div>
 *   </div>
 * </div>
 */
export const ProductModalController = {
  init() {
    const modal = document.querySelector( '.product-modal' );
    if ( !modal ) return;

    const triggers = document.querySelectorAll( '.product-trigger' );
    const panels   = modal.querySelectorAll( '[data-content]' );
    const closeBtn = modal.querySelector( '.product-modal__close' );
    const inner    = modal.querySelector( '.product-modal__inner' );
    if ( !triggers.length || !panels.length ) return;

    // 既存 is-<slug> クラスを一旦全部剥がすためのリスト
    const slugs = Array.from( panels ).map( ( p ) => p.dataset.content );

    const open = ( targetId ) => {
      panels.forEach( ( p ) => {
        p.classList.toggle( 'is-active', p.dataset.content === targetId );
      } );
      // モーダル root に is-<slug> を付け替え (背景色切替に使用)
      slugs.forEach( ( s ) => modal.classList.toggle( `is-${ s }`, s === targetId ) );
      modal.classList.add( 'is-active' );
      if ( inner ) inner.scrollTop = 0;
    };

    const close = () => {
      modal.classList.remove( 'is-active' );
    };

    triggers.forEach( ( trigger ) => {
      trigger.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        const target = trigger.dataset.target;
        if ( !target ) return;
        open( target );
      } );
    } );

    if ( closeBtn ) {
      closeBtn.addEventListener( 'click', close );
    }
  },
};
